import { gql } from "@apollo/client";

export const SystemBreadcrumbPath = gql`
    query SystemBreadcrumbPath($id: ID!) {
        system(id: $id) {
            id
            installedBaseNode {
                id
                title
                pathNodes {
                    id
                    title
                    nodeType {
                        id
                        key
                        name
                    }
                    assetLocation {
                        id
                    }
                    system {
                        id
                    }
                }
            }
        }
    }
`;
